// extracted by mini-css-extract-plugin
export default {"cvContainer":"cv-new_cvContainer__x3V33","content":"cv-new_content__JfsS-","experienceList":"cv-new_experienceList__P5mtY"};